import styled from "styled-components";

export const StyledLandingScreen = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  padding: 80px 30px 100px 30px;
  background-color: ${({ theme }) => theme.colors.background};
  gap: 30px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10% 30%;
  }

  h2 {
    color: ${({ theme }) => theme.colors.text};
    font-size: 20px;
  }
  p {
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }
`;

export const StyledHorizontalCarousel = styled.div`
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  gap: 24px;
  /* Hide the scrollbar for WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* If you want to hide the scrollbar for Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
`;
